import { StateType } from 'data/types'

import { TransactionType } from './types'

const getRootState = (state: StateType) => state.payments.transactions

export const getData = (state: StateType, type: TransactionType) => getRootState(state)[type]?.data

export const getItems = (state: StateType, type: TransactionType) =>
  getData(state, type)?.items ?? []

export const getNextPageUrl = (state: StateType, type: TransactionType) =>
  getData(state, type)?.next ?? undefined

export const isLoading = (state: StateType, type: TransactionType) =>
  getRootState(state)[type]?.loading

export const hasError = (state: StateType, type: TransactionType) =>
  getRootState(state)[type]?.error === undefined

export const getError = (state: StateType, type: TransactionType) =>
  getRootState(state)[type]?.error

export const getItem = (state: StateType, id: string) =>
  [
    ...(getData(state, TransactionType.CHARGE)?.items ?? []),
    ...(getData(state, TransactionType.DEPOSIT)?.items ?? []),
    ...(getData(state, TransactionType.WITHDRAWAL)?.items ?? [])
  ].find((trx) => trx.id === id)
